import { Navigation } from 'swiper';

if ( document.body.classList.contains( 'single-product' ) ) {
	// Hook into the slider settings
	wp.hooks.addFilter(
		'qala_theme.filter.slider_settings',
		'polestar_product_slider_settings',
		function( sliderSettings, target ) {
			if ( target.classList.contains( 'product-image-slider' ) ) {
				// Check if the modules array exists and include Navigation if not already included
				const existingModules = sliderSettings.modules || [];
				const newModules = [ ...new Set( [ ...existingModules, Navigation ] ) ];

				return {
					...sliderSettings,
					modules: newModules,
					loop: true,
					pagination: {
						el: '.swiper-pagination-enhanced',
						type: 'bullets',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
				};
			}

			return sliderSettings;
		}
	);
}
